import { makeAutoObservable } from "mobx";
import { RootStore, ServiceStore } from "@intrasync/stores";
// Using API types for ServiceStore entities
import type { Panel } from "types/common/ServiceStoreTypes";

class ProductionMonitor {
  rootStore: RootStore;
  enableAutoScroll = true;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  toggleEnableAutoScroll = () => {
    this.enableAutoScroll = !this.enableAutoScroll;
  };

  get castingDate() {
    const routerStore = this.rootStore.routerStore;
    if (!routerStore) {
      return "";
    }
    return routerStore.queryParams.castingDate;
  }

  get filteredPanelPlantData() {
    const panelStore = this.rootStore.panelStore as ServiceStore;
    if (!panelStore) {
      return [];
    }
    return panelStore.entities.filter((panelPlant) => {
      return panelPlant.castingDate === this.castingDate;
    });
  }

  get entities() {
    return this.filteredPanelPlantData;
  }
}

export default ProductionMonitor;
